
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { TypedVue } from "@/store/types";
import { TraitInfoV8 } from "./types";

@Component
export default class ElraReport8DevNextSteps extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ required: true }) lessPrioritizedTraits!: TraitInfoV8[];

  // Any signed-in user can open the assistant; the backend token endpoint still limits
  // each user to assessments they're permitted to view.
  get userCanAccessAssistant(): boolean {
    return !!this.$auth.user;
  }
}
